import React from "react";
import { NavLink } from "react-router-dom";
import { CONTRACT_ADDRESS } from "../../../constants/tokens";
import { Menu } from "antd";
import { BlockOutlined, GlobalOutlined, TagsOutlined } from "@ant-design/icons";
const { SubMenu } = Menu;

export default function NavMenu({ type }) {
  return (
    <Menu
      theme={"dark"}
      mode={type === "desktop" ? "horizontal" : "inline"}
      style={{ minWidth: 210 }}
    >
      <Menu.Item key="home">
        <NavLink to="/">Home</NavLink>
      </Menu.Item>
      <SubMenu icon={<BlockOutlined />} title="Blockchain">
        <Menu.Item key="blockchain:1">
          <NavLink to="/blockchain/transfers">Transfers</NavLink>
        </Menu.Item>
        <Menu.Item key="blockchain:2">
          <NavLink to="/blockchain/transactions">Transactions</NavLink>
        </Menu.Item>
      </SubMenu>
      <SubMenu icon={<TagsOutlined />} title="Protocol">
        <SubMenu key="protocol:1-2" title="Tokens">
          <Menu.Item key="tokens:1">
            <NavLink to={`/tokens/rise`}>Centric Rise (CNR)</NavLink>
          </Menu.Item>
          <Menu.Item key="tokens:2">
            <NavLink to="/tokens/cash">Centric Cash (CNS)</NavLink>
          </Menu.Item>
        </SubMenu>
        <SubMenu key="protocol:2-2" title="Contracts">
          <Menu.Item key="contracts:1">
            <NavLink to={`/contract/${CONTRACT_ADDRESS.rise}`}>
              Centric Rise (CNR)
            </NavLink>
          </Menu.Item>
          <Menu.Item key="contracts:2">
            <NavLink to={`/contract/${CONTRACT_ADDRESS.cash}`}>
              Centric Cash (CNS)
            </NavLink>
          </Menu.Item>
        </SubMenu>
        <Menu.Item key="protocol:3">
          <NavLink to="/burn">Burn History</NavLink>
        </Menu.Item>
      </SubMenu>
      <SubMenu icon={<GlobalOutlined />} title="Data">
        <Menu.Item key="data:1">
          <NavLink to="/data/prices">Price Blocks</NavLink>
        </Menu.Item>
        <Menu.Item key="data:2">
          <NavLink to="/holders">Holders</NavLink>
        </Menu.Item>
        <Menu.Item key="data:3">
          <NavLink to="/data/foundation">Foundation Addresses</NavLink>
        </Menu.Item>
      </SubMenu>
    </Menu>
  );
}
